import Footer from "../Footer";
import { investmenttype } from "../Array";
import { useParams } from "react-router-dom";

function Bankingservice() {
     const { id } = useParams();
   const inv = investmenttype.find(
  (item) => item.id === Number(id)
);

  return (
    <>
     <div className="container bank-type mt-4">
            <div className="mt-5">
              <h2 className="text-center">{inv.title}</h2>
    
              <div className="mt-5">
                {inv.sections.map((section, index) => (
                  <div key={index} className="d-flex flex-column gap-2">
                    <h4>{section.heading}</h4>
    
                    {Array.isArray(section.content) ? (
                      section.content.map((text, i) => (
                        <p key={i}>{text}</p>
                      ))
                    ) : (
                      <p>{section.content}</p>
                    )}
    
                    {index === 0 && section.pointheading && (
                      <h6 className="mt-2">{section.pointheading}</h6>
                    )}
    
                    {section.points && (
                      <ul className="pl-3 d-flex flex-column gap-3">
                        {section.points.map((point, i) => (
                          <li key={i}> <b>{point.key}</b> {point.value}</li>
                        ))}
                      </ul>
                    )}
    
                    <p className="">{section.h2}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <Footer />  
    </>
  )
}

export default Bankingservice
